import React, {Component} from 'react';
import {connect} from "react-redux";
import 'react-bootstrap';

import SideSearchBox from '../../../components/SideSearchBox';
import PlaceType from './PlaceType';

class DesMiddleRightSide extends Component {

    constructor(props)
    {
        super(props);
        this.state = {

        }
    }

    componentWillMount() { 

    }

    componentDidMount() {
           
    }
  
    componentWillUnmount() {

    }
    
    componentDidUpdate() {
        
    }

    componentWillReceiveProps(newProps) {

    } 
  
    render() {

        return (
            <div className="col-lg-4 p-4 recent-place">
                <div className="row">
                    <div className="col-md-11 ml-auto">
                        <SideSearchBox onSearch={(key)=>this.props.onSearchKeyChanged(key)}/>
                        <div className="side-box">
                            <h2 className="heading">{this.props.placeCategoriesTitle}</h2>
                            <PlaceType
                                id = {this.props.id}
                                businesses = {this.props.businesses}
                                getPlaceByType = {(destinationID, typeID) => this.props.getPlaceByType(destinationID, typeID)}
                                viewAll = {() => this.props.viewAll()}
                            />
                        </div>
                    </div> 
                </div>
            </div> 
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(DesMiddleRightSide);